export default "__VITE_ASSET__6bf6197f__"